import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { BaseAuthPage } from 'pages/auth/BaseAuthPage';
import { Typography } from '@material-ui/core';
import { useOptOutMutation, IMailingId } from 'graphql/types';
import { getUrlParamValue } from 'utils';

export const OptOutPage = () => {
    const { t } = useTranslation();
    const [optOut, { loading }] = useOptOutMutation();
    const token = getUrlParamValue('token');

    useEffect(() => {
        if (!token) return;

        optOut({
            variables: { token: token, mailingIds: [IMailingId.Reminder] },
        });
    }, []);

    return (
        <BaseAuthPage>
            <Typography variant="body2">
                {loading
                    ? t('employee.optOutLoading')
                    : t('employee.optOutSuccess')}
            </Typography>
        </BaseAuthPage>
    );
};
